// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"1406": "2fafa60e","5624": "4e08a4d0","6704": "c240a4cc","9537": "d659abef",}[chunkId] + ".css"
}